export default __webpack_public_path__ + "static/media/Brew of Acute Aptitude.dfd3a17f.jpg";